export class SerializationTools {
    static UpdateLocations(particleSet, globalState, frame) {
        particleSet.editorData = {
            locations: [],
        };
        // Store node locations
        const blocks = frame ? frame.nodes.map((n) => n.content.data) : particleSet.attachedBlocks;
        for (const block of blocks) {
            const node = globalState.onGetNodeFromBlock(block);
            particleSet.editorData.locations.push({
                blockId: block.uniqueId,
                x: node ? node.x : 0,
                y: node ? node.y : 0,
                isCollapsed: node ? node.isCollapsed : false,
            });
        }
        globalState.storeEditorData(particleSet.editorData, frame);
    }
    static Serialize(particleSet, globalState, frame) {
        this.UpdateLocations(particleSet, globalState, frame);
        const selectedBlocks = frame ? frame.nodes.map((n) => n.content.data) : undefined;
        const serializationObject = particleSet.serialize(selectedBlocks);
        return JSON.stringify(serializationObject, undefined, 2);
    }
    static Deserialize(serializationObject, globalState) {
        globalState.nodeParticleSet.parseSerializedObject(serializationObject);
        globalState.onIsLoadingChanged.notifyObservers(false);
    }
    static AddFrameToParticleSystemSet(serializationObject, globalState, currentSystemSet) {
        this.UpdateLocations(currentSystemSet, globalState);
        globalState.nodeParticleSet.parseSerializedObject(serializationObject, true);
        globalState.onImportFrameObservable.notifyObservers(serializationObject);
        globalState.onIsLoadingChanged.notifyObservers(false);
    }
}
//# sourceMappingURL=serializationTools.js.map